import { Clock } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const OnboardingStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const statusOptions: ComboboxFilterOption<string>[] = [
    { label: 'Not Started', value: 'open' },
    { label: 'In Progress', value: 'launched|quoted|quote_accepted' },
    // TODO: Clean up this quick fix - payroll_connected currently shows as "Payroll Connected"
    // for all employers, but should be "Not Started" for platform employers and "Almost Complete"
    // for self-serve employers. See: https://linear.app/thatch/issue/MM-152/follow-up-refactor-employeronboarding-status
    { label: 'Payroll Connected', value: 'payroll_connected' },
    { label: 'Almost Complete', value: 'bank_account_created' },
    { label: 'Complete', value: 'completed' },
  ]

  const filteredOptions = statusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Onboarding Status', options: filteredOptions || [] }]}
        placeholder='Search onboarding statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={statusOptions || []}
          noSelectionText='Onboarding Status'
          pluralIdentifier='onboarding statuses'
        >
          <Clock size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default OnboardingStatusFilter
